import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
    isEmpty(value: any) {
        return typeof value == 'string' && !value.trim() || typeof value == 'undefined' || value === null;
    }

    filter(items: any[], filtersMap: any): any[] {
        //console.log("applyFilter filter", items, filtersMap);
        let results = [];
        if (!items || !filtersMap) {
          return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        items.filter(
            (item: any) => {
                if(this.applyFilter(item, filtersMap)){
                    results.push(item);
                }
            }
        );
        //console.log("applyFilter results", results);
        return results;
    }

    transform(items: any[], filtersMap: any): any[] {
        //console.log("filter pipe transform", items, filtersMap);
        if (!items || !filtersMap) {
          return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter((item: any) => this.applyFilter(item, filtersMap));
    }

    checkNumber(itemField: any, filterField: any, filterOp: any){
        //console.log("checkNumber:", itemField, filterField, "filterOp", filterOp);
        switch(filterOp){
          case '=':
            if(itemField === filterField){
              return true;
            }
            break;
          case 'IN':
            if(Array.isArray(itemField)){
              for(let item of itemField){
                if(item == filterField){
                    return true;
                }
              }
            }
            break;
        }
        return false;
    }

    checkString(itemField: any, filterField: any, filterOp: any){
        //console.log("checkString:", itemField, filterField, "filterOp", filterOp);
        if (this.isEmpty(itemField)) {
            return false;
        }else if (itemField.toLowerCase().indexOf(filterField.toLowerCase()) === -1){
            return false;
        }
        return true;
    }

    checkDate(itemField: any, filterField: any, filterOp: any){
        //console.log("checkDate", itemField, filterOp, filterField);
        if (this.isEmpty(itemField)) {
            return false;
        }else{
            switch(filterOp){
                case "==":
                    if (itemField == filterField){
                        return true;
                    }
                    break;
                case "!=":
                    if (itemField != filterField){
                        return true;
                    }
                    break;
                case "<":
                    if (itemField < filterField){
                        return true;
                    }
                    break;
                case ">":
                    if (itemField > filterField){
                        return true;
                    }
                    break;
                case "<=":
                    if (itemField <= filterField){
                        return true;
                    }
                    break;
                case ">=":
                    if (itemField >= filterField){
                        return true;
                    }
                    break;
                default:
                    return false;
            }
            return false;
        }
    }

    applyFilter(item: any, filtersMap: any): boolean {
        let filterResult: boolean = true;
        //console.log("PP|FILTER applyFilter", item, filtersMap);

        filtersMap.forEach((filterMap: boolean, key: string) => {
            let localFilterResult = false;
            let filterMoment = null;
            let filterValue = null;
            let filterOp = null;
            let filterName = null;
            filterOp = filterMap["op"];
            filterName = filterMap["name"];

            switch(filterMap["type"]){
                case 'number':
                    filterValue = filterMap["value"];
                    if(filterValue){
                        if(filterMap["itemKey"]){
                            filterResult = filterResult && this.checkNumber(item[filterMap["itemKey"]], filterValue, filterOp);
                        }else{
                            filterResult = filterResult && this.checkNumber(item[key], filterValue, filterOp);
                        }
                    }
                    break;
                case 'string':
                    filterValue = filterMap["value"];
                    //console.log("applyfilter string", filterMap, item, filterMap["itemKey"], key);
                    if(filterValue){
                        if(filterMap["itemKey"]){
                            filterResult = filterResult && this.checkString(item[filterMap["itemKey"]], filterValue, filterOp);
                        }else{
                            filterResult = filterResult && this.checkString(item[key], filterValue, filterOp);
                        }
                    }
                    break;
                case 'date':
                    filterValue = filterMap["value"];
                    if(filterValue){
                        if(filterMap["itemKey"]){
                            filterResult = filterResult && this.checkDate(item[filterMap["itemKey"]], filterValue, filterOp);
                        }else{
                            filterResult = filterResult && this.checkDate(item[filterName], filterValue, filterOp);
                        }
                    }
                    break;
                case 'array':
                    //console.log("applyFilter array", key, filterMap, item);
                    filterValue = filterMap["value"];
                    if(filterValue.length){
                        filterValue.forEach((value: any) => {
                            if(filterMap["filterKey"]){
                                //console.log("applyFilter array key", item[filterMap["itemKey"]], value[filterMap["filterKey"]]);
                                localFilterResult = localFilterResult || item[filterMap["itemKey"]] == value[filterMap["filterKey"]];
                            }else{
                                //console.log("applyFilter array nokey", item[filterMap["itemKey"]], value);
                                localFilterResult = localFilterResult || item[filterMap["itemKey"]] == value;
                            }
                            //console.log("applyFilter localFilterResult", localFilterResult);
                        });
                    }else{
                        localFilterResult = true;
                    }
                    //console.log("applyFilter filterResult", filterResult, localFilterResult);
                    filterResult = filterResult && localFilterResult;
                    //console.log("applyFilter filterResult", filterResult);
                    break;
                case 'action':
                    filterValue = filterMap["value"];
                    if(!this.isEmpty(filterValue)){
                        //console.log("filterMap action", filterMap);
                    }
                    break;
                default:
                    //console.log("applyFilter filterValue", key, filterMap);
            }
        });
        //console.log("applyFilter filterResult last", filterResult);
        return filterResult;
    }
}
